module.exports = __webpack_public_path__ + "img/spbu1.37fbea97.png";